const Urls = {
  login: "/asymptomatic-portal/login",
  send_otp: "/asymptomatic-portal/send-verification-otp",
  verify_otp: "/asymptomatic-portal/verify-forgot-otp",
  reset_password: "/asymptomatic-portal/reset-password",
  get_demographics: "/asymptomatic-portal/demographics/get",
  get_demographic_percentage:
    "/asymptomatic-portal/demographics/get_stepwise_percentage",
  save_demographics: "/asymptomatic-portal/demographics/add",
  change_password: "/asymptomatic-portal/change-password",
  get_ealsfrs_lists: "/asymptomatic-portal/eals_frs/get",
  save_ealsfrs: "/asymptomatic-portal/eals_frs/add",
  get_ares_score_lists: "/asymptomatic-portal/ares_score/get",
  save_ares_score: "/asymptomatic-portal/ares_score/add",
  get_cpib_form_list: "/asymptomatic-portal/cpib_form/get",
  save_cpib_form: "/asymptomatic-portal/cpib_form/add",
  get_road_list: "/asymptomatic-portal/roads/get",
  save_road_session: "/asymptomatic-portal/roads/add",
  get_ecas_form_list: "/asymptomatic-portal/ecas/get",
  get_ecas_form_details: "/asymptomatic-portal/ecas/get-details",
  authoriseAutoLoginUser: "/asymptomatic-portal/authorize_user",
  check_consent_form_status: "/asymptomatic-portal/consent-form-status",
  upload_pdf_for_genetic_confirmation:
    "/asymptomatic-portal/genetic-confirmation-document/upload",
  get_genetic_confirmation_document:
    "/asymptomatic-portal/genetic-confirmation-document/get",
  view_genetic_confirmation_document:
    "/asymptomatic-portal/genetic-confirmation-document/view",
  remove_genetic_confirmation_document:
    "/asymptomatic-portal/genetic-confirmation-document/remove",
  get_start_speech_session_link: "/asymptomatic-portal/get_speech_session",
  get_asymptomatic_client_code: "/asymptomatic-portal/get_client_code",
  get_proctored_session_details:
    "/asymptomatic-portal/get_proctored_session_details",
  get_actigraph_session_log_list:
    "/asymptomatic-portal/get_actigraph_session_log_list",

  get_report_data: process.env.REACT_APP_PATIENT_PORTAL_BASE_URL + "report",
  get_notes_data: process.env.REACT_APP_PATIENT_PORTAL_BASE_URL + "notes",
  get_files_data: process.env.REACT_APP_PATIENT_PORTAL_BASE_URL + "file",
  get_chart_category_list:
    process.env.REACT_APP_PATIENT_PORTAL_BASE_URL + "category",
 

  // seperate term
  get_ecas_form_details_for_app_page: "/app_user/ecas-form/show",
  get_actigraph_list: "/asymptomatic-portal/get_actigraph_data",

  // ecas study
  get_ecas_study_demographics: "/ecas-study-portal/demographics/get",
  get_ecas_study_demographic_percentage:
    "/ecas-study-portal/demographics/get_stepwise_percentage",
  save_ecas_study_demographics: "/ecas-study-portal/demographics/add",

  get_physical_ecas_form_list: "/ecas-study-portal/physical-ecas-form/get",
  save_physical_ecas_form: "/ecas-study-portal/physical-ecas-form/save",
  get_physical_ecas_form_url:
    "/ecas-study-portal/physical-ecas-form/get_pdf_url",

  // speech
  get_speech_client_code: "/portal/speech/get_client_code",
  get_speech_study_demographics: "/speech-study-portal/demographics/get",
  save_speech_study_demographics: "/speech-study-portal/demographics/save",
  check_speech_study_demographics_als_user:
    "/speech-study-portal/demographics/check_als_user",
  check_speech_consent_form_status: "/speech-study-portal/consent-form-status",
  add_new_speech_participant: "/speech-study-portal/participant/add",
  generate_neurostamp_id:
    "/speech-study-portal/participant/generate_neurostamp_id",
  get_voice_recording_details: "/speech-study-portal/voice-recording/get",
  save_voice_recording: "/speech-study-portal/voice-recording/save",
  get_alsfrs_question_list: "/speech-study-portal/alsfrs/get",
  save_speech_alsfrs: "/speech-study-portal/alsfrs/save",

  get_profile_details: "/speech-study-portal/get_profile_details",
  update_profile_details: "/speech-study-portal/update_profile_details",

  get_ecas_user_type: "/ecas-study-portal/get_user_type",
  add_new_ecas_participant: "/ecas-study-portal/participant/add",
  add_new_le_study_participant: "/le-study-portal/participant/add",

  get_le_study_demographics: "/le-study-portal/demographics/get",
  save_le_study_demographics: "/le-study-portal/demographics/save",
  get_le_study_demographic_percentage:
    "/le-study-portal/demographics/get_stepwise_percentage",
  get_le_study_participant_details: "/le-study-portal/participant/get",
  get_le_study_session_list: "/le-study-portal/participant/get-session-list",
  get_le_study_eals_frs_score: "/le-study-portal/alsfrs/get",
  get_le_study_inclinic_alsfrs_score: "/le-study-portal/alsfrs/inclinic/get",
  get_le_study_in_clinic_session_list: "/le-study-portal/clinic-session/get",
  get_le_study_language: "/le-study-portal/get-language",

  get_ecas_study_alsfrsr_score_list: "/ecas-study-portal/alsfrs-r/get",
  save_ecas_study_alsfrsr: "/ecas-study-portal/alsfrsr/save",
  get_ecas_study_participant_date_created: "/ecas-study-portal/participant/date-created/get",
  save_ecas_study_alsfrsr_upload_form: "/ecas-study-portal/alsfrs-r-upload-form/save",
  get_physical_ecas_study_alsfrsr_form_url: "/ecas-study-portal/physical-ecas-alsfrs-r-form/get_pdf_url",
  get_available_accounts: "/asymptomatic-portal/get-available-accounts",
};
export default Urls;
